import React, { useState, useEffect } from 'react';
import { Select, MenuItem } from '@material-ui/core';

const StatusSelect = ({
  selectProps, itemId, defaultValue, onChangeValue,
}) => {
  const [status, setStatus] = useState(defaultValue);

  useEffect(() => {
    setStatus(defaultValue);
  }, [defaultValue]);
  //   {
  //     RESERVATION_STATUS.find(s => s.value === row.status).label;
  //   }
  const handleStatusChange = (event) => {
    setStatus(event.target.value);
    if (onChangeValue) onChangeValue(itemId, event.target.value);
  };

  const handleOnClick = (e) => {
    e.stopPropagation();
  };
  return (
    <Select
      value={status}
      onChange={handleStatusChange}
      onClick={handleOnClick}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...selectProps}
    >
      <MenuItem value="I">진행중</MenuItem>
      <MenuItem value="A">상담완료</MenuItem>
      {/* <MenuItem value={'C'}>작업완료</MenuItem> */}
    </Select>
  );
};

export default StatusSelect;
